import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import { Dropdown } from 'react-bootstrap'

function CDropdown({ data, CustomLink, pageRouterComp, InternalRouting }) {
  const [show, setShow] = useState(false)
  return (
    <>
      {/* Preload hidden links (optional for SEO/spiders) */}
      {data?.oChildren?.map(c => {
        return (
          <a rel='nofollow' style={{ display: 'none' }} href={`/${c?.sSlug}`} key={`d-none${c?._id}`}>
            {c?.sTitle}
          </a>
        )
      })}

      <Dropdown
        show={show}
        style={{ marginInline: '8px', paddingRight: '16px' }}
        onMouseEnter={() => setShow(true)}
        onClick={() => setShow(!show)}
        onMouseLeave={() => setShow(false)}
        id={`uniq${data?._id}`}>
        <Dropdown.Toggle variant="link" id={data._id} className={`${styles.navMore} d-block`}>
          {data.sTitle}
        </Dropdown.Toggle>

        <Dropdown.Menu id={data._id} className={`${styles.dropdownMenu}`}>
          {data?.oChildren.map(c => {
            return (CustomLink && InternalRouting) ? (
              pageRouterComp ? <CustomLink
                key={c?._id}
                href={`/${c?.sSlug}`}
              >
                <a className="dropdown-item">{c?.sTitle}</a>
              </CustomLink> : <CustomLink
                key={c?._id}
                href={`/${c?.sSlug}`}
                className="dropdown-item"
              >
                {c?.sTitle}
              </CustomLink>
            ) : (
              <a
                rel='nofollow'
                key={c?._id}
                className="dropdown-item"
                href={`/${c?.sSlug}`}
              >
                {c?.sTitle}
              </a>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

CDropdown.propTypes = {
  InternalRouting: PropTypes.bool,
  data: PropTypes.object.isRequired,
  pageRouterComp: PropTypes.bool,
  CustomLink: PropTypes.func // Accepting as prop
}

export default CDropdown
